import {
  PointsContainer,
  PointsLabel,
} from '@/components/user-profile/reward-points/components';
import RewardPointsProgressSlider from '@/components/user-profile/reward-points/RewardPointsProgressSlider';
import useAppSelector from '@/hooks/useAppSelector';
import useAuth from '@/hooks/useAuth';
import { myRewardPointsSelector } from '@/redux/selectors/activitySelector';
import { getWellPrizeEntries } from '@/utils/wellPrizeHelpers';
import { Box } from '@mui/material';
import React from 'react';

const MonthlyPointsActivity: React.FC<{ userId?: number }> = ({ userId }) => {
  const rewardPoints = useAppSelector(myRewardPointsSelector);
  const { isSuperAdmin, isRwAdmin, user } = useAuth();
  const isAdmin = isSuperAdmin || isRwAdmin;
  const isWellPrize = !isAdmin && !!user?.companies[0]?.wellPrize;

  return (
    <PointsContainer>
      <PointsLabel variant={'h2'} mb={4}>
        Monthly Points Earned
      </PointsLabel>
      <RewardPointsProgressSlider userId={userId} />
      {!userId && (
        <Box display="flex" alignItems="center" gap={8}>
          <Box>
            {`${Number(rewardPoints?.earnedPoints).toLocaleString('en')} / ${
              rewardPoints?.availablePoints
                ? Number(rewardPoints?.availablePoints).toLocaleString('en')
                : 0
            }`}
          </Box>
          {isWellPrize && (
            <Box>
              {`${getWellPrizeEntries(
                rewardPoints?.totalPoints
              )} of 10 WellPrize entries earned`}
            </Box>
          )}
        </Box>
      )}
    </PointsContainer>
  );
};

export default MonthlyPointsActivity;
